var map = {
	"./addAmount": 673,
	"./addAmount.js": 673,
	"./addAmountForItem": 919,
	"./addAmountForItem.js": 919,
	"./close": 6591,
	"./close.js": 6591,
	"./createDndObject": 1500,
	"./createDndObject.js": 1500,
	"./fetch": 5276,
	"./fetch.js": 5276,
	"./getAuthorizationKey": 7195,
	"./getAuthorizationKey.js": 7195,
	"./getWidgetFromItem": 3549,
	"./getWidgetFromItem.js": 3549,
	"./popup": 9413,
	"./popup.js": 9413,
	"./popupEmitter": 2792,
	"./popupEmitter.js": 2792,
	"./publishToOthers": 6667,
	"./publishToOthers.js": 6667,
	"./requestAuthorizationKey": 7454,
	"./requestAuthorizationKey.js": 7454,
	"./saveWidget": 6954,
	"./saveWidget.js": 6954,
	"./saveWidgetForItem": 3656,
	"./saveWidgetForItem.js": 3656,
	"./setAmount": 3525,
	"./setAmount.js": 3525,
	"./setAmountForItem": 7820,
	"./setAmountForItem.js": 7820,
	"./setDatetime": 6149,
	"./setDatetime.js": 6149,
	"./setHeight": 1127,
	"./setHeight.js": 1127,
	"./setTitle": 128,
	"./setTitle.js": 128,
	"./setWidth": 1283,
	"./setWidth.js": 1283,
	"./startDnd": 6892,
	"./startDnd.js": 6892,
	"./stopDnd": 653,
	"./stopDnd.js": 653,
	"./subtractAmount": 3023,
	"./subtractAmount.js": 3023,
	"./subtractAmountForItem": 2510,
	"./subtractAmountForItem.js": 2510
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5195;